import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

import type { StatusLight } from './types';

export interface StatusConfig {
  label: string;
  icon: typeof CheckCircleOutlinedIcon;
  guidance: string;
  palette: 'success' | 'warning' | 'error';
}

/**
 * Colorblind-friendly status icons — each uses a distinct shape + symbol:
 *   GREEN  → Circle + checkmark
 *   YELLOW → Triangle + exclamation
 *   RED    → Octagon + X
 */
export const STATUS_CONFIG: Record<StatusLight, StatusConfig> = {
  GREEN: {
    label: 'Verified',
    icon: CheckCircleOutlinedIcon,
    guidance:
      'Everything looks good. Fields are still editable if corrections are needed.',
    palette: 'success',
  },
  YELLOW: {
    label: 'Needs Review',
    icon: WarningAmberOutlinedIcon,
    guidance:
      'Review the data below and verify accuracy before the visit.',
    palette: 'warning',
  },
  RED: {
    label: 'Issue Detected',
    icon: DangerousOutlinedIcon,
    guidance: 'This must be resolved before the visit.',
    palette: 'error',
  },
};
